(ns frontend.view.metabase-dashboard.view
  (:require
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.metabase-dashboard.events :as events]
   [frontend.view.metabase-dashboard.sub :as sub]
   [re-frame.core :as rf]
   [ui.components.tab-strip.view :as tab-strip]))

(defn generic-metabase-report
  [dashboard-id]
  (rf/dispatch [::events/init dashboard-id])
  (fn [dashboard-id]
    (let [dashboard-url @(rf/subscribe [::sub/embed-url dashboard-id])
          pipeline-filtering? @(rf/subscribe [::sub/pipeline-filtering? dashboard-id])
          shown-pipeline-id @(rf/subscribe [::sub/shown-pipeline-id])
          non-archived-pipelines @(rf/subscribe [::sub/active-oppo-pipelines])]
      [default-page-layout/view
       {:metabase? true}
       [:div
        {:class "flex flex-col flex-1 overflow-auto max-h-full"}
        [:div
         {:class "flex flex-1 flex-col gap-0"}
         (when pipeline-filtering?
           [:div
            {:class "p-2 pb-0"}
            [tab-strip/view
             {:tabs         (->> non-archived-pipelines
                                 (map (fn [p]
                                        {:value (:db/id p)
                                         :label (:pipeline/name p)}))
                                 (sort-by :label)
                                 (vec))
              :selected-tab shown-pipeline-id
              :on-change!   (fn [pipeline-id]
                              (rf/dispatch [::events/select-pipeline-id dashboard-id pipeline-id]))}]])
         ^{:key (str "metabase-" dashboard-url)}
         [:iframe
          {:src          dashboard-url
           :class        "flex-auto bg-base-light"
           :frame-border 0}]]]])))

(defmethod routing/render-view :metabase-dashboard
  [{:keys [route-params _view-params]}]
  (let [dashboard-id (-> route-params
                         :id
                         js/parseInt)]
    ^{:key (str "metabase-dashboard-" dashboard-id)}
    [generic-metabase-report dashboard-id]))
